const sendMail = toMailId => {
  return window.open(`mailto:${toMailId}`);
};
export { sendMail };
